module.exports = __webpack_public_path__ + "static/media/Breakout.a3f8cc26.png";